export class VersionInformationHistory {
  VersionNumber: string;
  VersionDate: string;
  Title: string;
  Description: string[];
}